import { render } from "./SubscribeToAddonDialog.vue?vue&type=template&id=9b0f6f4a&scoped=true"
import script from "./SubscribeToAddonDialog.vue?vue&type=script&lang=js"
export * from "./SubscribeToAddonDialog.vue?vue&type=script&lang=js"

import "./SubscribeToAddonDialog.vue?vue&type=style&index=0&id=9b0f6f4a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0f6f4a"]])

export default __exports__